/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, signal } from '@angular/core';
import { HttpClientService } from '@core/services/http-client/http-client.service';
import { API_URL_CONSTANT } from '@sharedModule/constants/api-url.constant';
import { Observable } from 'rxjs';
import { LoaderService } from '@sharedModule/services/loader/loader.service';
import { MessageHandlerService } from '@core/services/message-handler/message-handler.service';
import { SecondPromptService } from '@feature/dashboard/promt/services/second-prompt.service';
import { HttpClient, HttpContext, HttpContextToken } from '@angular/common/http';
import { setParams } from '@sharedModule/utils/param.utils';
import { ResponseIdentity } from '@sharedModule/models/server-response-identity.model';
import { DOCXLIST_INTERFACE } from '../types/docxList-interface';
import { DOCX_DOWNLOAD_INTERFACE } from '../types/download-interface';
import { UPLOAD_DOCX_INTERFACE } from '../types/uploadDocx-interface';

export interface Filter {
  page: number;
  pageSize: number;
  sortOrder: 'asc' | 'desc';
  userId: string;
};
export const BYPASS_HEADERS = new HttpContextToken<boolean>(() => false);

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  url_Signal = signal<string | null>(null);
  constructor(
    public httpClient: HttpClientService,
    public httpclient: HttpClient,
    public messageHandlerService: MessageHandlerService,
    public loaderService: LoaderService,
    public promptService: SecondPromptService
  ) {}

  getDocxListAdminLevl(
    filter: Filter
  ): Observable<ResponseIdentity<DOCXLIST_INTERFACE[]>> {
    return this.httpClient.get(
      API_URL_CONSTANT.fetchDocxAdminLevel,
      setParams(filter)
    );
  }
  getDocxListUserLevl(
    filter: Filter
  ): Observable<ResponseIdentity<DOCXLIST_INTERFACE[]>> {
    return this.httpClient.get(
      API_URL_CONSTANT.fetchDocxUserLevel,
      setParams(filter)
    );
  }
  // how to send the data
  generateDocx(): Observable<ResponseIdentity<DOCX_DOWNLOAD_INTERFACE>> {
    return this.httpClient.post(
      API_URL_CONSTANT.generateDocx,
      this.promptService.promptResponseData()
    );
  }
  downloadFile(url: string): Observable<Blob> {
    return this.httpclient.get(url, {
      responseType: 'blob',
      context: new HttpContext().set(BYPASS_HEADERS, true)
    });
  }
  documentUpload(
    file: File
  ): Observable<ResponseIdentity<UPLOAD_DOCX_INTERFACE>> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.httpClient.post(API_URL_CONSTANT.fileUpload, formData);
  }
}
